import script from "./captcha.vue?vue&type=script&lang=ts&setup=true"
export * from "./captcha.vue?vue&type=script&lang=ts&setup=true"

import "./captcha.vue?vue&type=style&index=0&id=8c4c9332&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c4c9332"]])

export default __exports__